<script>
	import {
		Styles,
		Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink,
		Dropdown, DropdownToggle, DropdownMenu, DropdownItem
	} from 'sveltestrap';

	import Login from './Login.svelte';
	import Status from './Status.svelte';
	import MediaList from './MediaList.svelte';

	export let server = window.location.protocol + "//" + window.location.host;
	export let func;
	export let operation;
	export let node;
	export let refresh;
	export let haveBlocks = true;

	let token = undefined;
	let login = undefined;
	let password = undefined;
	let isOpen = false;
	let isStatus = true;
	let isMedia = false;

	function updateNavbar(event) {
    	isOpen = event.detail.isOpen;
  	}

	function showPane(event) {
		let pane = event.target.firstChild.data;
		isStatus = false;
		isMedia = false;
		switch (pane) {
			case "Status":
			default:
				isStatus = true;
				break;
			case "Media":
				isMedia = true;
				break;
		}
	}

	function logOut(event) {
		token = undefined;
	}
</script>

<main>
	<Styles />

	{#if !token}
		<Login {server} bind:token={token} bind:login={login} bind:password={password} />
	{:else}
		<Navbar color="light" light expand="md">
			<NavbarBrand href="https://easytools.tv/services/easyplayout/">
				<img alt="EasyPlayout" src="./easyplayout_long.png" height="25ex" />
			</NavbarBrand>
			<NavbarToggler on:click={() => (isOpen = !isOpen)} />
			<Collapse {isOpen} navbar expand="md" on:update={updateNavbar}>
				<Nav class="ms-auto" navbar>
					<NavItem>
						<NavLink active={isStatus} href="#" on:click={showPane}>Status</NavLink>
					</NavItem>
					<NavItem>
						<NavLink active={isMedia} href="#" on:click={showPane}>Media</NavLink>
					</NavItem>
					<Dropdown nav inNavbar>
						<DropdownToggle nav caret><strong>{login}</strong> account</DropdownToggle>
						<DropdownMenu end>
							<DropdownItem on:click={logOut}>Log out</DropdownItem>
						</DropdownMenu>
					</Dropdown>
				</Nav>
			</Collapse>
		</Navbar>

		<div id="pane">
			{#if isStatus}
				<Status {server} {token} {login} {password} {func} {operation} {node} {refresh} />
			{:else if isMedia}
				<MediaList {server} {token} {login} {password} {haveBlocks} />
			{/if}
		</div>
	{/if}
</main>

<style>
	#pane {
		margin: 2em;
	}
	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
